import { useEffect, useRef, useState, useContext } from "react";
import Button from "../../components/button";
import SectionTitle from "../../components/section-title";
import Parallax from "parallax-js";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";

const WoInfoContainer = ({ contRef, classOption = "section-pb" }) => {
    const sceneEl = useRef(null);
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    return (
        <div
            className={`about-us  position-relative align-self-center ${classOption}`}
            ref={contRef}
        >
            <div className="container">
                <div className="row mb-n7">
                    <div className="col-xl-12 col-lg-12 text-center">
                        <div className="about-content">
                            <span
                                ref={(el) => (textRefs.current[0] = el)}
                                className="date-meta "
                            >
                                <b>
                                    Welcome to{" "}
                                    <span className="g-color">
                                        NEOGROWTH SECOND CAREER
                                    </span>{" "}
                                    for Women
                                </b>
                                {/* <span className="hr"></span> */}
                            </span>
                            <p
                                ref={(el) => (textRefs.current[1] = el)}
                                className="text-dark mb-5"
                            >
                                NeoGrowth Second Career for women is a unique
                                initiative which creates opportunities for women
                                returning to the workforce after a career break.
                            </p>
                            <p
                                ref={(el) => (textRefs.current[1] = el)}
                                className="text-dark "
                            >
                                NeoGrowth values life experiences gained while
                                on a career break.
                            </p>
                            <p
                                ref={(el) => (textRefs.current[1] = el)}
                                className="text-dark mb-5"
                            >
                                This initiative provides plethora of career
                                options to choose from.
                            </p>
                            <p
                                ref={(el) => (textRefs.current[1] = el)}
                                className="text-dark mb-5"
                            >
                                <b>
                                    It is simple to get back to your career
                                    growth path.
                                </b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

WoInfoContainer.propTypes = {
    classOption: PropTypes.string,
    contRef: PropTypes.string,
};

export default WoInfoContainer;
